import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
declare var $: any;
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  cmsList = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) {
    this.getAdminGroup();
  }
  getAdminGroup() {
    this.DefaultComponent.loaderShow();
    this.CommonService.getAdminGroup().subscribe((data) => {
      if (data.status) {
        this.cmsList = data.news_list;
      } else {
        if (data.token_expire) {
          localStorage.removeItem('login_token');
          this.router.navigate(['/']);
        }
      }
      this.DefaultComponent.loaderHide();
    });
  }
  delete_news(id) {
    this.DefaultComponent.loaderShow();
    var param = { news_id: id };
    this.CommonService.deleteAdminGroup(param).subscribe((data) => {
      this.DefaultComponent.loaderHide();
      if (data['status']) {
        this.toastr.success(data.message)
        this.getAdminGroup();
      } else {
        if (data.token_expire) {
          localStorage.removeItem('login_token');
          this.router.navigate(['/']);
        } else {
          this.toastr.error(data.message)
        }
      }
    });
  }
  ngOnInit(): void {
  }
}
